import {ElMessage} from 'element-plus';

/**
 * 成功提示
 * @param message
 */
const $success = (message) => {
    ElMessage({
        showClose: false,
        message: message,
        type: 'success',
    })
}

/**
 * 警告提示
 * @param message
 */
const $warning = (message) => {
    ElMessage({
        showClose: false,
        message: message,
        type: 'warning',
    })
}

/**
 * 警告提示
 * @param message
 */
const $error = (message) => {
    ElMessage({
        showClose: false,
        message: message,
        type: 'error',
    })
}

/**
 * 时间格式化
 * @param date 日期
 * @param fmt 格式
 * @returns {*} date
 */
const $formatDate = (date, fmt) => {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

/**
 * 计算相差几个月
 * 输入格式：yyyy-MM-DD或yyyy-MM
 *
 * @param date1 时间1
 * @param date2 时间2
 * @returns {number}
 */
const $differenceSeveralMonths = (date1, date2) => {
    // 拆分年月日
    date1 = date1.split('-');
    // 得到月数
    date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
    // 拆分年月日
    date2 = date2.split('-');
    // 得到月数
    date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
    return Math.abs(date1 - date2); //Math.abs()取绝对值
}

/**
 * 大写
 * @param money
 * @returns {string}
 */
const smallToBig = (money) => {
    //  将数字金额转换为大写金额
    let cnNums = [
        '零',
        '壹',
        '贰',
        '叁',
        '肆',
        '伍',
        '陆',
        '柒',
        '捌',
        '玖'
    ] // 汉字的数字
    let cnIntRadice = ['', '拾', '佰', '仟'] // 基本单位
    let cnIntUnits = ['', '万', '亿', '兆'] // 对应整数部分扩展单位
    let cnDecUnits = ['角', '分', '毫', '厘'] // 对应小数部分单位
    let cnInteger = '整' // 整数金额时后面跟的字符
    let cnIntLast = '圆' // 整数完以后的单位
    // 最大处理的数字
    let maxNum = 999999999999999.9999
    let integerNum // 金额整数部分
    let decimalNum // 金额小数部分
    // 输出的中文金额字符串
    let chineseStr = ''
    /* var parts // 分离金额后用的数组，预定义*/
    if (money === '') {
        return ''
    }

    money = parseFloat(money)
    if (money >= maxNum) {
        // 超出最大处理数字
        return '超出最大处理数字'
    }
    if (money === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger
        return chineseStr
    }

    // 四舍五入保留两位小数,转换为字符串
    money = Math.round(money * 100).toString()
    integerNum = money.substr(0, money.length - 2)
    const endTwoNum = money.substr(money.length - 2, money.length - 1) // 判断倒数第二位是否是0
    if (!endTwoNum || endTwoNum == 0) {
        decimalNum = '0' + money.substr(money.length - 1)
    } else {
        decimalNum = money.substr(money.length - 2)
    }

    // 获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0
        let IntLen = integerNum.length
        for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
                zeroCount++
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0]
                }
                // 归零
                zeroCount = 0
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q]
            }
        }
        chineseStr += cnIntLast
    }
    // 小数部分
    if (decimalNum !== '') {
        let decLen = decimalNum.length
        for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
        }
    }
    if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '' || /^0*$/.test(decimalNum)) {
        chineseStr += cnInteger
    }
    return chineseStr
};

// 获取支付类型
const getValue = (tmp) => {
    let result;
    switch (tmp) {
        case 0:
            result = '季度';
            break;
        case 1:
            result = '半年';
            break;
        case 2:
            result = '年';
            break;
        case 3:
            result = '一次性'
            break;
        default:
            result = '-'
    }
    return result;
}
export default {
    smallToBig,
    getValue,
    install: (Vue) => {
        Vue.config.globalProperties['$success'] = $success;
        Vue.config.globalProperties['$warning'] = $warning;
        Vue.config.globalProperties['$error'] = $error;
        Vue.config.globalProperties['$formatDate'] = $formatDate;
        Vue.config.globalProperties['$differenceSeveralMonths'] = $differenceSeveralMonths;
    }
}